import { type FC, useEffect, useState } from "react";
import { useShopfrontDispatch } from "../../../_Bootstrap/hooks";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import Button from "../../../Common/Buttons/Button";
import PopupManager from "../../../Common/Popups/PopupManager";
import { type DashboardItemEditType, type ReportOptionType } from "./DashboardModify";
import { DashboardModifyItemForm } from "./DashboardModifyItemForm";

interface Props {
    report: ReportOptionType | null;
    filterUser: boolean;
    options: Array<ReportOptionType>;
    onSubmit: (report: DashboardItemEditType) => void;
    onMountChange: (mounted: boolean) => void;
}

export const DashboardModifyItemDialog: FC<Props> = ({
    options,
    report,
    onMountChange,
    filterUser: defaultFilterUser,
    onSubmit,
}) => {
    const dispatch = useShopfrontDispatch();

    const [ selected, setSelected ] = useState(report);
    const [ filterUser, setFilterUser ] = useState(defaultFilterUser);

    useEffect(() => {
        onMountChange(true);

        return () => {
            onMountChange(false);
        };
    }, [ onMountChange ]);

    return (
        <>
            <div className="min-w-[400px]">
                <DashboardModifyItemForm
                    report={selected}
                    setReport={setSelected}
                    filterUser={filterUser}
                    setFilterUser={setFilterUser}
                    options={options}
                />
            </div>
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    onClick={() => {
                        dispatch(hideDialog());
                    }}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    classes={[ "button-save" ]}
                    onClick={() => {
                        if(!selected) {
                            PopupManager.error("Please select a report.");

                            return;
                        }

                        dispatch(hideDialog());

                        onSubmit({
                            report: selected.value,
                            filterUser,
                        });
                    }}
                >
                    Update
                </Button>
            </div>
        </>
    );
};
